import { Component } from "react";


const title = "Who We Are";
const desc = "We are a global esports platform focused on competitive integrity, player growth, and community-driven gaming experiences.";



class AboutSection extends Component {
    render() { 
        const {imgUrl} = this.props;
        return (
          <section className="about-section">
            <div className="container">
              <div className="section-wrapper padding-top">
                <div className="row gx-2 align-items-center">

                <div className="col-lg-6">
                  <div className="about-image fade-left-overshoot fade-delay-1">
                    <img src={imgUrl} alt="about-image" />
                  </div>
                </div>


                  <div className="col-lg-6 col-md-10">
                    <div className="about-wrapper">
                      <div className="section-header about-section-h2">
                        <h2 className="text-anim-typing  js-animate delay-md">
                          {title}
                        </h2>
                      </div>
                      <div className="about-content">
                        <p className="text-anim-fade-down js-animate delay-md">
                          {desc}
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

        );
    }
}
 
export default AboutSection;